<template>
    <div style="display: inline-block;color:white">
        <!--<Tooltip v-if="$store.state.user.user"  placement="top" transfer :content="$store.state.user.user.company?$store.state.user.user.company.name:'暂未选择'">-->
            <!--<span class="user-name" v-if="$store.state.user.user.current_company">{{$store.state.user.user.company?$store.state.user.user.company.name:'暂未选择'}}</span>-->
        <!--</Tooltip>-->
        <!--<Poptip :title="$t('l.my_msg')" transfer word-wrap="" :width="300">-->
            <!--<span class="user-name">-->
               <!--<Badge style="margin: 0 20px;cursor:pointer;" class-name="badge-icon" :offset="[12,-3]" type="info" :count="companyTasks.length">-->
                <!--<Icon type="ios-notifications-outline" size="22"></Icon>-->
            <!--</Badge>-->
            <!--</span>-->
            <!--<div slot="content">-->
                <!--<CellGroup style="max-height: 400px;overflow-y: auto;"  v-if="companyTasks.length">-->
                    <!--<Cell v-for="item in companyTasks" :title="topics[item.topic].name" :label="item.insert_time" :extra="item.content.tip" @click.native="onCellClick(item)"/>-->
                <!--</CellGroup>-->
                <!--<CellGroup v-else>-->
                    <!--<Cell>{{$t('l.no_msg')}}</Cell>-->
                <!--</CellGroup>-->
            <!--</div>-->
        <!--</Poptip>-->
        <lg-modal :title="modal.title" :show="modal.show" :loading="modal.loading" @on-submit="onSubmit"
                  @on-cancel="modal.loading=false;modal.show = false;" confirm-text="l.agree">
            <template v-if="!!currentTask">
                <template v-if="currentTask.topic === topics.SIGNATURE_APPROVE.topic">
                    <signature-approve ref="taskHandler" :task="currentTask"></signature-approve>
                </template>
            </template>
            <template slot="buttons">
                <Button type="error" @click="onReject">{{$t('l.refuse')}}</Button>
            </template>
        </lg-modal>

    </div>
</template>

<script>
    import util from '../../libs/util';
    import LgModal from "../my-components/lg-modal";
    import SignatureApprove from "./task-handlers/signature-approve";
    export default {
        name: "task-center",
        components: {SignatureApprove, LgModal},
        data () {
            return {
                companyTasks: [],
                modal: {
                    show: false,
                    title: this.$t('l.notify_msg'),
                    loading: false,
                    currentIndex: -1,
                    task: {

                    }
                },
                currentTask: null,
                topics: {
                    SIGNATURE_APPROVE: {
                        name: this.$t('l.sign_application'),
                        topic: 'SIGNATURE_APPROVE'
                    }
                }
            }
        },
        methods: {
            getTasks() {
                util.ajax.get('/task/getlist').then(res => {
                    if (!res.code){
                        res.data.forEach(task => util.parseJSONResult(task, 'content'))
                        this.companyTasks = res.data;
                    } else{
                        util.chooseCurrentCompany();
                    }
                })
            },
            onSubmit () {
                util.ajax.put('/task/resolve', {
                    id: this.currentTask.id,
                    resolved: 1
                }).then(res => {
                    this.$refs.taskHandler.resolve();
                    this.modal.show = false;
                    this.currentTask = null;
                }).then(() => {
                    this.getTasks();
                })
            },
            onReject () {
                util.ajax.put('/task/resolve', {
                    id: this.currentTask.id,
                    resolved: -1
                }).then(res => {
                    this.$refs.taskHandler.reject();
                    this.modal.show = false;
                    this.currentTask = null;
                }).then(() => {
                    this.getTasks();
                })
            },
            onCellClick (item) {
                this.currentTask = item;
                this.modal.show = true;
            }
        },
        mounted () {
            if (this.$store.state.user.user && this.$store.state.user.user.current_company) this.getTasks();
        }
    }
</script>

<style scoped>
</style>